export default __webpack_public_path__ + "static/media/US_AS_Workshop-logo.663ab97d.jpg";